import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslate} from "../../../system/useTranslate";
import {BreadCrumb} from "primereact/breadcrumb";
import Icon from "../../../system/components/icon";
import PageHeaderButton from "../../components/page-header-button";
import {Button} from "primereact/button";
import {TabPanel, TabView} from "primereact/tabview";
import ProjectSettingsDialog from "../../projects/components/project-settings-dialog";
import Identification from "./tabs/identification";
import {useGoal} from "../../../models/goal/use-goal";
import GoalProjectDialog from "../components/goal-project-dialog";
import {setWorkspaceMembership} from "../../../system/app-slice";
import {Menu} from "primereact/menu";
import {CLOSED_GOAL_STATUSES, GOAL_STATUS, OPEN_GOAL_STATUSES} from "../../../models/goal-update/goal-update-api";
import "../components/goal-updates.css";
import {usePermission} from "../../../system/usePermission";
import GoalSettingsDialog from "../components/goal-settings-dialog";
import Can from "../../../system/can";
import SelectableTabsButton, {useSelectableTabs} from "../../components/selectable-tabs-button";
import {usePublishAiScope} from "../../../system/ai-scope-context";

function Goal(props) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const params = useParams();
    const [goalData, setGoalData] = useState();
    const [breadCrumb,setBreadCrumbData] = useState([]);
    const [activeIndex,setActiveIndex] = useState(0);
    const [goalSettingsDialogVisible,setGoalSettingsDialogVisible] = useState(false);
    const translate = useTranslate();
    const navigate = useNavigate();
    const goal = useGoal();
    const dispatch = useDispatch();
    const permission = usePermission();

    const tabs = [
        { id: "identification", label: "goal-identification", icon: "mi mi:fingerprint", view:Identification }
    ];
    const {visibleTabs, selectedIds, toggleTab} = useSelectableTabs(tabs, `visible-tabs:goal:${params.id}`, activeIndex, setActiveIndex);
    usePublishAiScope({
        activeTab: visibleTabs[activeIndex]?.id,
        entityType: "goal",
        entityDocumentId: goalData?.documentId || params.id,
        selectedEntityIds: [goalData?.documentId || params.id].filter(Boolean),
    });

    useEffect(()=>{
        const _goalData = workspaceMembershipData?.workspace.goals.find(p=>p.id===+params.id);
        setGoalData(_goalData);
        setBreadCrumbData([
            {label:translate("goals"), command:()=>{navigate("/goals")}},
            {label:_goalData?.title},
            {label:translate(visibleTabs[activeIndex]?.label || visibleTabs[0].label)}
        ]);
    },[workspaceMembershipData, params?.id]);
    const updateGoal = async (goalData, updateData)=>{
        // if (!permission.can("goal.update", true))return;
        let _data = await goal.updateGoal(goalData?.documentId, updateData);
        if (!_data) return null;
        if (_data.archivedAt) {
            const activeGoals = (workspaceMembershipData?.workspace.goals || []).filter(
                (item) => item.documentId !== goalData.documentId,
            );
            dispatch(setWorkspaceMembership({
                ...workspaceMembershipData,
                workspace: {...workspaceMembershipData.workspace, goals: activeGoals},
            }));
            setGoalSettingsDialogVisible(false);
            navigate("/goals");
            return _data;
        }
        let _goals = [...workspaceMembershipData?.workspace.goals];
        let _goalIndex = _goals.findIndex(g=>g.documentId===goalData.documentId);
        _goals[_goalIndex] = {...goalData, ..._data}

        dispatch(setWorkspaceMembership({...workspaceMembershipData, workspace: {...workspaceMembershipData.workspace, goals:_goals}}));
        setGoalSettingsDialogVisible(false);
        return _data;
    }

    return (
        <div className="h-full flex flex-column min-h-0">
            {goalData && (
                <BreadCrumb
                    separatorIcon={<Icon icon="mi mi:chevron_left text-xs"/>}
                    className="bg-transparent border-none text-xs"
                    model={breadCrumb}
                />
            )}

            <PageHeaderButton
                end={
                    <div className="flex gap-2 align-items-center">
                        <Can permission="create-new-goals">
                            <Button label={translate("goal-settings")} className="text-xs p-button-xl w-fit" icon={<Icon icon="mi mi:edit" className="text-sm pl-2"/>} onClick={()=>{setGoalSettingsDialogVisible(true)}}/>
                            <SelectGoalStatus goalData={goalData}/>
                        </Can>

                    </div>
                }
                title={goalData?.title||""}
                // description={goalData?.description}
            />

            {/* تب‌ها */}
            <div className="flex-1 min-h-0 relative">
                <SelectableTabsButton tabs={tabs} selectedIds={selectedIds} onChange={toggleTab} className="absolute z-5" style={{top: ".45rem", left: ".75rem"}}/>
                <TabView
                    lazy
                    activeIndex={activeIndex}
                    onTabChange={(e)=>{
                        setActiveIndex(e.index);
                        setBreadCrumbData(prv=>{
                            const next = Array.isArray(prv) ? [...prv] : [];
                            next[2] = {label:translate(visibleTabs[e.index].label)};
                            return next;
                        });
                    }}
                    panelContainerClassName="flex-1 min-h-0 p-0 border-noround"
                    className="h-full flex flex-column">
                    {visibleTabs.map((tab, tabIndex) => {
                        const TabContent = tab.view;
                        return (
                        <TabPanel
                            key={tab.id}
                            header={translate(tab.label)}
                            leftIcon={<Icon icon={tab.icon} className="pl-2" />}
                            className="h-full text-xs">
                            {tabIndex === activeIndex && <div className="h-full min-h-0 overflow-hidden">
                                <TabContent goalData={goalData} />
                            </div>}
                        </TabPanel>
                    )})}
                </TabView>
            </div>
            {/*<GoalProjectDialog singleTab="goal" visible={goalProjectDialogVisible} payload={goalData} onSubmit={(e)=>{updateGoal(goalData, {title:e.state.title, description:e.state.description, owner:e.state.owner?.id})}} onHide={()=>{setGoalProjectDialogVisible(false)}}/>*/}
            <GoalSettingsDialog
                onSubmit={(e)=>{updateGoal(goalData, e.value)}}
                onArchive={() => updateGoal(goalData, {
                    archivedAt: new Date().toISOString(),
                    archivedBy: workspaceMembershipData,
                })}
                goalData={goalData}
                visible={goalSettingsDialogVisible}
                setVisible={setGoalSettingsDialogVisible}
            />
        </div>
    );
}

// «بروزرسانی هدف» (docs/tasks/17-goal-updates.md): the status list opens the update page with that status selected
function SelectGoalStatus({goalData}) {
    const navigate = useNavigate();
    const menu = useRef(null);
    const current = GOAL_STATUS[goalData?.goalStatus];
    const item = (status) => ({
        label: GOAL_STATUS[status].label,
        template: (menuItem, options) => (
            <button
                type="button"
                className={`gu-status-menu__item ${goalData?.goalStatus === status ? "is-current" : ""}`}
                onClick={options.onClick}
            >
                <span className={`gu-status-menu__dot gu-status-menu__dot--${GOAL_STATUS[status].tone}`}/>
                <span className="gu-status-menu__label">{GOAL_STATUS[status].label}</span>
                {goalData?.goalStatus === status && <span className="pi pi-check gu-status-menu__check"/>}
            </button>
        ),
        command: () => navigate(`/goals/${goalData?.documentId}/update-status?status=${status}`),
    });
    const model = [
        {label: "اهداف باز", items: OPEN_GOAL_STATUSES.map(item)},
        {label: "اهداف بسته", items: CLOSED_GOAL_STATUSES.map(item)},
    ];

    return (
        <>
            <Menu model={model} popup ref={menu} className="gu-status-menu rtl"/>
            <Button
                className="text-xs p-button-xl w-fit p-button-outlined gap-2"
                icon={<Icon icon="mi mi:update" className="text-sm"/>}
                label="بروزرسانی هدف"
                badge={current?.label}
                badgeClassName="p-badge-secondary text-2xs"
                onClick={(event) => menu.current?.toggle(event)}
                aria-haspopup
            />
        </>
    );
}
export default Goal;
